// extracted by mini-css-extract-plugin
export var standaloneTable = "_fp-0";
export var withExtraHeader = "_fp-1";